// extracted by mini-css-extract-plugin
export default {"UrlRow":"UrlRow_UrlRow__OmwbG","UrlLabel":"UrlRow_UrlLabel__S8+ZO"};